import { InjectionToken, signal, type Signal } from '@angular/core';

export const WISHLIST_READ_CONTEXT = new InjectionToken<Signal<unknown | null>>('Wishlist authenticated read context', {
  providedIn: 'root',
  factory: (): Signal<unknown | null> => signal<null>(null),
});
